import { Link } from "react-router-dom";
import './Breadcrumb.css';

function Breadcrumb({ categoryParent, categoryName, categoryId, productName }) {
  return (
    <div className="breadcrumb">
      <Link>{categoryParent} </Link>
      /
      <Link 
        to={`/category/${categoryId}`}
        state={{ categoryName: categoryName }}> {categoryName}</Link>
      <span>/</span>
      {productName}
    </div>
  );
}

export { Breadcrumb };